export function reportProductionMapperListResponse(json, headers) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      reportProductionId: resource.objectId,
    })),
    total: headers.get("X-Total-Count") ? parseInt(headers.get("X-Total-Count").split("/").pop(), 10) : 1000,
  };
}

export function fixUpdateReportProductionId(json) {
  return {
    data: {...json, id: json.objectId},
  };
}

export function fixCreateReportProductionId(params, json) {
  return {
    data: {...params.data, id: json.result.objectId},
  };
}

export function fixGetManyReportProduction(json) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      reportProductionId: resource.objectId,
    })),
  };
}

export function reportProductionMapperGetOneResponse(json) {
  return {
    data: {...json.result, id: json.result.objectId, reportProductionId: json.result.objectId},
  };
}